/*export const APTOS_CONFIG = {
	id: '177',
	rpcUrl: 'https://aptos.testnet.porto.movementlabs.xyz/v1',
	name: 'testnet',
};*/
/*export const MOVE_VALUE = 100000000;

export const APTOS_CONFIG = {
	id: '126',
	rpcUrl: 'https://mainnet.movementnetwork.xyz/v1',
	name: 'mainnet',
};*/

import { LockTimeType } from 'utils/lockDuration';

export const APTOS_CONFIG = {
	id: '126',
	rpcUrl: 'https://mainnet.movementnetwork.xyz/v1',
	name: 'mainnet',
};
export const MOVE_VALUE = 100000000;

export const APTOS_LOCKING_PERIOD: LockTimeType = {
	difference: 'seconds',
	duration: 1000,
};

export const CONTRACT_TOKEN = 'MOVE';

export const CONTRACT_ADDRESS =
	'0xdda6afe1b6611d7991c4b3b55b35120877a25415e72939516281cf1352863503';

export const MOVEMENT_BASE_URL = 'https://mainnet.movementnetwork.xyz/v1';

export const INDEXER_URL = 'https://indexer.mainnet.movementnetwork.xyz';

export const COIN_NAME = 'Move Coin';
